<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cog', fontSet: 'fad'}"
	[headerText]="T.EXAM_SCHEDULE_SETTINGS_DIALOG | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<form>
			<!--MANUAL SCHEDULE-->
			<mat-form-field [@zoomInOnEnter] [@zoomOutOnLeave] color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-calendar-days" fontSet="fad" inline />
					{{ T.LABEL_SCHEDULE_MODE | translate }}
				</mat-label>
				<mat-select [formControl]="form.controls.scheduleMode">
					<mat-option [value]="ExamFlowScheduleMode.AutoSchedule">
						<mat-icon fontIcon="fa-table-cells-row-lock" fontSet="fad" inline matIconSuffix />
						{{ T.LABEL_AUTO_SCHEDULE | translate }}
					</mat-option>
					<mat-option [value]="ExamFlowScheduleMode.ManualSchedule">
						<mat-icon fontIcon="fa-calendar-users" fontSet="fad" inline matIconSuffix />
						{{ T.LABEL_MANUAL_SCHEDULE | translate }}
					</mat-option>
					<mat-option [value]="ExamFlowScheduleMode.FirstRunSchedule">
						<mat-icon fontIcon="fa-diagram-cells" fontSet="fad" inline matIconSuffix />
						{{ T.LABEL_FIRST_RUN_SCHEDULE | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<!--RUN MODE-->
			<mat-form-field [@zoomInOnEnter] [@zoomOutOnLeave] color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-running" fontSet="fad" inline />
					{{ T.LABEL_RUN_MODE | translate }}
				</mat-label>
				<mat-select [formControl]="form.controls.runMode">
					<mat-option [value]="ExamFlowRunMode.Default">
						<mat-icon fontIcon="fa-sync" fontSet="fad" inline matIconSuffix />
						{{ T.LABEL_DEFAULT_RUN | translate }}
					</mat-option>
					<mat-option [value]="ExamFlowRunMode.SingleRun">
						<mat-icon fontIcon="fa-running" fontSet="fad" inline matIconSuffix />
						{{ T.LABEL_SINGLE_RUN | translate }}
					</mat-option>
					<mat-option [value]="ExamFlowRunMode.NRun">
						<mat-icon fontIcon="fa-list-ol" fontSet="fad" inline matIconSuffix />
						{{ T.LABEL_N_RUN | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			@if (form.value.runMode === ExamFlowRunMode.NRun) {
				@let runCtrl = form.controls.nRunMaxRuns;
				<mat-form-field color="accent" [@zoomInOnEnter] [@zoomOutOnLeave]>
					<mat-label>{{ T.LABEL_N_RUN_COUNT | translate }}</mat-label>
					<input
						matInput
						type="number"
						inputmode="numeric"
						pattern="[0-9]*"
						[formControl]="runCtrl"
						[max]="maxRunLimit()"
						[min]="0"
					/>
					<mat-hint>{{ T.EXAM_SCHEDULE_SETTINGS_DIALOG_RUN_MAX_HINT | translate: {maxLimit: maxRunLimit()} }}</mat-hint>
					@if (runCtrl.hasError("required")) {
						<mat-error>
							{{ T.ERROR_REQUIRED | translate }}
						</mat-error>
					} @else {
						<mat-error>
							{{ T.LABEL_N_RUN_COUNT_MIN | translate: {maxLimit: maxRunLimit()} }}
						</mat-error>
					}
				</mat-form-field>
			}

			@if (hasChanged()) {
				<sim-warning-message [text]="T.EXAM_SCHEDULE_SETTINGS_DIALOG_WARNING_MSG" />
			}
			<button #submitButton (click)="submit()" hidden></button>
		</form>
	</ng-container>
	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontIcon: 'fa-times', fontSet: 'fas'}" [label]="T.BUTTON_CANCEL" color="warn" />
		<sim-button
			(onClick)="submitButton.click()"
			[disabled]="!hasChanged()"
			[icon]="{fontIcon: 'fa-check', fontSet: 'fas'}"
			[label]="T.BUTTON_SAVE"
		/>
	</ng-container>
</sim-basic-material-dialog>
